import Api from 'services/Api'
import { store } from 'store/reducers'
import { getCSV, getUserName } from 'services/Utilities'
import { createErrorNotification } from 'store/actions/notifications'
import { Format } from 'services/Dates'
import { t } from 'translations'

type EventData = Pick<MData.Event, 'start' | 'end' | 'isExtraShift' | 'isOvertime' | 'comment'> & { employeeNumber: string; positionCode: string }
const exportCsvRaw = async (filter: { rangeStart: string }): Promise<void> => {
  const {
    resources: { usersById, positionsById }
  } = store.getState() as MStore.RootState

  const { success, result: events }: { success: boolean; result: MData.Event[] } = await Api.post('schedule/schedule/query', {
    ...filter,
    showCancelledShift: false
  })
  if (!success) return store.dispatch(createErrorNotification(store.dispatch))

  const data: EventData[] = []
  for (const event of events) {
    const { start, end, positionId, employeeId, isExtraShift = false, isOvertime = false, comment = '' } = event

    // If no employee is assigned or employee does not exist, skip this event
    if (!employeeId || !usersById[employeeId]) continue

    data.push({
      employeeNumber: getUserName(employeeId, { employeeNumberOnly: true }) ?? '',
      start: Format(start) ?? '',
      end: Format(end) ?? '',
      positionCode: (positionsById[positionId] || {}).positionCode,
      isExtraShift,
      isOvertime,
      comment
    })
  }

  getCSV(
    data,
    ['employeeNumber', 'start', 'end', 'positionCode', 'isExtraShift', 'comment', 'isOvertime'],
    t('manager.schedule.reports.CSV_REPORT_RAW_TITLE', {
      start: Format(filter.rangeStart, { outFormat: 'date' }),
      end: Format(filter.rangeStart, { outFormat: 'date' })
    })
  )
}

export default exportCsvRaw
